<template>
  <div class="animated fadeIn">
    <div class="card p-4 mb-1">
      <div class="form-group row">
        <div class="col-md-12">
          <label for="txtName"
            ><small
              class="text-danger"
              v-if="form.name.required"
              >*</small
            >
            Nome:</label
          >
          <div class="input-group">
            <span class="input-group-addon"><i class="fas fa-user"></i></span>
            <b-form-input
              type="text"
              id="txtName"
              name="txtName"
              :placeholder="'Digite o nome'"
              v-model="form.name.value"
              :size="form.name.maxlength"
              :required="form.name.required"
              :state="form.name.state"
            >
            </b-form-input>
          </div>
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="col-md-6">
          <label
            ><small
              class="text-danger"
              v-if="form.document.required"
              >*</small
            >
            CPF/CNPJ:</label
          >
          <div class="input-group">
            <span class="input-group-addon"
              ><i class="fas fa-id-badge"></i
            ></span>
            <b-form-input
              type="text"
              :placeholder="'Digite o CPF ou CNPJ do Contato'"
              v-model="form.document.value"
              :size="form.document.maxlength"
              :required="form.document.required"
              :state="form.document.state"
              v-mask="['###.###.###-##', '##.###.###/####-##']"
              disabled
            ></b-form-input>
          </div>
        </div>
        <div
          class="col-md-6"
          v-if="form.numId.value"
        >
          <label
            ><small
              class="text-danger"
              v-if="form.numId.required"
              >*</small
            >
            {{ $t('associates.number') }}:</label
          >
          <div class="input-group">
            <span class="input-group-addon"
              ><i class="fas fa-university"></i
            ></span>
            <b-form-input
              type="text"
              :placeholder="`Digite o ${$t('associates.number')} do Associado`"
              v-model="form.numId.value"
              :size="form.numId.maxlength"
              :required="form.numId.required"
              :state="form.numId.state"
              disabled
            ></b-form-input>
          </div>
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="col-md-6">
          <label for="txtGroup"
            ><small
              class="text-danger"
              v-if="form.tipoPessoa.required"
              >*</small
            >
            Tipo Pessoa:</label
          >
          <div class="input-group">
            <span class="input-group-addon"
              ><i class="fas fa-user-tag"></i
            ></span>
            <b-form-select
              v-model="form.tipoPessoa.value"
              :options="form.tipoPessoa.options"
              disabled
            >
              <template slot="first">
                <option :value="null">
                  {{ $lang.Common.PlaceholderSelect }}
                </option>
                <option value="PF">FÍSICA</option>
                <option value="PJ">JURÍDICA</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-6">
          <label
            ><small
              class="text-danger"
              v-if="form.dataNascimento.required"
              >*</small
            >
            {{
              personType == 'PF'
                ? 'Data de Nascimento'
                : 'Data Abertura da Empresa'
            }}:</label
          >
          <div class="input-group">
            <span class="input-group-addon"
              ><i class="fas fa-calendar-alt"></i
            ></span>
            <b-form-input
              type="text"
              :placeholder="$lang.Common.DatePlaceholder"
              v-model="form.dataNascimento.value"
              :size="form.dataNascimento.maxlength"
              :required="form.dataNascimento.required"
              :state="form.dataNascimento.state"
              v-mask="['##/##/####']"
            >
            </b-form-input>
          </div>
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="col-md-12">
          <label for="txtGroup"
            ><small
              class="text-danger"
              v-if="form.leadOriginID.required"
              >*</small
            >
            Origem:</label
          >
          <div class="input-group">
            <span class="input-group-addon"
              ><i class="fas fa-bullhorn"></i
            ></span>
            <b-form-select
              v-model="form.leadOriginID.value"
              :options="form.leadOriginID.options"
              disabled
            >
              <template slot="first">
                <option :value="null">
                  {{ $lang.Common.PlaceholderSelect }}
                </option>
              </template>
            </b-form-select>
          </div>
        </div>
      </div>
      <div
        v-if="!boardArchived"
        class="form-group row pt-3"
      >
        <div class="col-md-12">
          <button
            type="button"
            class="btn btn-third btn-sm"
            v-on:click="onUpdate"
            v-b-tooltip.hover
            :title="$lang.Common.Tooltip.ButtonSave"
          >
            <i class="fa fa-check-circle"></i>
            <span class="d-md-down-none">{{
              $lang.Common.Buttons.Save
            }}</span></button
          >&nbsp;
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CrmDetailsPerson from './person.js'
export default CrmDetailsPerson
</script>



// WEBPACK FOOTER //
// src/views/private/crm/details/person/person.vue